import React from 'react';
import { motion } from 'framer-motion';

const VideoSection = () => {
  return (
    <section className="relative bg-neutral-900 overflow-hidden" data-testid="video-section">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="w-full"
      >
        {/* Full width video — preload metadata only so it doesn't compete
            with above-the-fold image bandwidth */}
        <video 
          className="w-full h-auto block"
          autoPlay 
          muted 
          loop 
          playsInline
          preload="auto"
        >
          <source src="/SOULBOARD_grid.mp4" type="video/mp4" />
        </video>
      </motion.div>
    </section>
  );
};

export default VideoSection;
